import React from 'react';

import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import Seo from '../../../../components/Misc/Seo';

import projectImage1 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_1.png';
import projectImage2 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_2.png';
import projectImage3 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_3.png';
import projectImage4 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_4.png';
import projectImage5 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_5.png';
import projectImage6 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_6.png';
import projectImage7 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_7.png';
import projectImage8 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_8.png';
import projectImage9 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_9.png';
import projectImage10 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_10.png';

import Data_NORCATUndergroundExperience from './Data_NORCATUndergroundExperience';

function Work_NORCATUndergroundExperience() {
    const siteUrl = 'https://studio.norcat.org';
    const canonical = `${siteUrl}/OurWork/norcat-underground-experience`;
    const title = 'NORCAT Underground Experience | Immersive Mine Training';
    const description =
        'Explore a developing underground mine before arriving on site with the NORCAT Underground Experience from Studio NORCAT.';
    const socialImage = `${siteUrl}${projectImage1}`;
    const sliderImages = [
        projectImage1,
        projectImage2,
        projectImage3,
        projectImage4,
        projectImage5,
        projectImage6,
        projectImage7,
        projectImage8,
        projectImage9,
        projectImage10,
    ].map((image, index) => ({
        image,
        alt: `NORCAT Underground Experience project preview ${index + 1}`,
    }));

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={socialImage}
                ogImageAlt="Preview of the NORCAT Underground Experience"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={socialImage}
                twitterImageAlt="Preview of the NORCAT Underground Experience"
            />
            <DetailedHeader
                heading="Go Underground Before You Go On Site"
                client="NORCAT"
                service="Experiential Learning"
                date="2026"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=Kcwc5Vr7eec"
                images={sliderImages}
            />
            {Data_NORCATUndergroundExperience.content}
        </>
    );
}

export default Work_NORCATUndergroundExperience;
